export const SELLER_FIELDS = [
  "lessorCompanyName",
  "lessorPersonalIdentificationNumber",
  "lessorHeadquartersAddress",
  "lessorSalesPersonName",
  "lessorPhoneNumber",
  "lessorTransactionAccountNumber",
] as const;
